var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 21.317,
    viewBox: "0 0 49.954 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.954,19.5a6.459,6.459,0,0,1,.84-3.193l-4.147-4.147a6.489,6.489,0,0,1-6.459-.042q-.042.048-.088.094L3.65,22.661a2,2,0,0,1-2.828,0l-.236-.235a2,2,0,0,1,0-2.829L11.035,9.148A2.006,2.006,0,0,1,11.4,8.86a6.5,6.5,0,1,1,12.1.026l4.568,4.568a6.5,6.5,0,0,1,4.91.057l4.486-4.486a6.5,6.5,0,1,1,2.923,3.206l-4.2,4.2A6.5,6.5,0,1,1,23.954,19.5Zm2.889,0a3.611,3.611,0,1,0,3.612-3.612A3.616,3.616,0,0,0,26.843,19.5Zm13-13a3.611,3.611,0,1,0,3.611-3.611A3.615,3.615,0,0,0,39.843,6.5Zm-26,0a3.612,3.612,0,1,0,3.612-3.611A3.616,3.616,0,0,0,13.842,6.5Z",
    fill: "#ccc"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.c3e71aa2b2734151a4be9866c347d93d.svg";
export { ForwardRef as ReactComponent };